module.exports = __webpack_public_path__ + "img/banner_04.db5de5ad.jpg";